module.exports = __webpack_public_path__ + "img/banner.d8ec9be1.png";